import React, { useContext } from "react";
import PropTypes from "prop-types";
import { HdfDataContext } from "../index";
import Section from "./Section";
import { calculateAge } from "cxa-utils/date";

const FemaleSection = ({ id, ...props }) => {
  const members = useContext(HdfDataContext).eligibleMembers || [];
  if (Array.isArray(members) && members.length > 0) {
    const femaleMembers = members.filter(
      member => member.gender === "Female" && calculateAge(member.dateOfBirth) >= 12
    );
    return femaleMembers.length > 0 ? <Section members={femaleMembers} {...props} /> : "";
  }
  return "";
};

FemaleSection.propTypes = {
  members: PropTypes.array,
  id: PropTypes.string,
};

export default FemaleSection;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/FemaleSection.js